<template>
    <div class="flex items-center">
        <div class="text-sm mr-3">{{ data.meta.from }} - {{ data.meta.to }} of {{ data.meta.total }}</div>
        <div class="">
            <button class="text-grey-dark p-2 rounded-full leading-none focus:outline-none"
                :class="data.links.prev ? 'hover:bg-grey-light' : 'cursor-not-allowed text-grey'"
                :disabled="!data.links.prev"
                @click="$emit('prev', {url: data.links.prev, page: (data.meta.current_page - 1)})">
                <arrow-left-icon />
            </button>
            <button class="text-grey-dark p-2 rounded-full leading-none focus:outline-none"
                :class="data.links.next ? 'hover:bg-grey-light hover:text-grey-darker' : 'cursor-not-allowed text-grey'"
                :disabled="!data.links.next"
                @click="$emit('next', {url: data.links.next, page: (data.meta.current_page + 1)})">
                <arrow-right-icon />
            </button>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            data: {
                type: Object,
                required: true,
                default () {
                    return {}
                }
            }
        },
        components: {
            ArrowLeftIcon: () =>
                import ( /* webpackChunkName: "arrow-left-icon" */ '@/icons/ArrowLeft.vue'),
            ArrowRightIcon: () =>
                import ( /* webpackChunkName: "arrow-right-icon" */ '@/icons/ArrowRight.vue')
        }
    }
</script>